<div class="form-holder {{ documentDirection }}" *ngIf="phoneConfig">
    <serviceos-ng-local-loader
        [showLoader]="showLoader"
    ></serviceos-ng-local-loader>
    <div class="form-header">
        <span class="form-title">{{ phoneConfig?.title }}</span>
    </div>
    <div
        class="form-content"
        [ngClass]="{ 'form-visible': userPhonesFormExpanded }"
    >
        <serviceos-ng-alert
            class="error-alert"
            *ngIf="formErrorMessage"
            [type]="'error'"
        >
            {{ formErrorMessage }}
        </serviceos-ng-alert>
        <ul class="list" *ngIf="(phones | async)?.length; else noPhonesItem">
            <li
                *ngFor="let phone of phones | async"
                class="item"
                [ngClass]="{ selected: phone.default }"
            >
                <div class="left-column">
                    <serviceos-ng-system-icon
                        [icon]="'pinned-deafult-choosed'"
                        (click)="setAsDefault(phone)"
                    ></serviceos-ng-system-icon>
                    <span class="formatted-phone">{{ phone.value }}</span>
                    <!-- <span class="formatted-phone">{{ formatPhone(phone.value) }}</span> -->
                </div>
                <div class="right-column">
                    <serviceos-ng-link
                        [type]="'secondary'"
                        [size]="'small'"
                        (click)="deletePhone(phone.id)"
                    >
                        <span class="delete">{{ phoneConfig.delete_button_title }}</span>
                    </serviceos-ng-link>
                </div>
            </li>
        </ul>
        <span class="form-label-title">{{ phoneConfig?.add_form?.title }}</span>
        <form
            [formGroup]="userPhonesForm"
            (ngSubmit)="formSubmit()"
            id="user-phones-form"
        >
            <div class="row">
                <div class="col-12 phone-field-holder">
                    <!-- <serviceos-ng-form-field>
                        <serviceos-ng-label>Phone number</serviceos-ng-label>
                        <input
                            [serviceosNgInput]="phone?.value"
                            [error]="
                                phone?.invalid &&
                                (phone?.dirty || phone?.touched)
                            "
                            [specialFieldType]="'decimal'"
                            type="text"
                            id="phone"
                            placeholder=""
                            name="phone"
                            formControlName="phone"
                        />
                        <serviceos-ng-error-message>Please enter a valid phone number</serviceos-ng-error-message>
                    </serviceos-ng-form-field> -->
                    <ngx-intl-tel-input
                        [cssClass]="'phone-field'"
                        [preferredCountries]="preferredCountries"
                        [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="true"
                        [searchCountryFlag]="true"
                        [searchCountryField]="[
                            SearchCountryField.Iso2,
                            SearchCountryField.Name
                        ]"
                        [selectFirstCountry]="false"
                        [selectedCountryISO]="selectedCountryICO"
                        [maxLength]="15"
                        [phoneValidation]="true"
                        [separateDialCode]="separateDialCode"
                        [numberFormat]="PhoneNumberFormat.National"
                        [customPlaceholder]="customPlaceholder"
                        name="phone"
                        formControlName="phone"
                        (countryChange)="countryChange($event.iso2)"
                    >
                    </ngx-intl-tel-input>
                    <small class="phone-error-message">
                        {{ phoneConfig?.add_form?.phone_input_error }}
                    </small>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <button type="submit">
                        {{ phoneConfig?.add_form?.confirm_button_title }}
                    </button>
                </div>
            </div>
        </form>
        <div class="add-phone-btn-holder row" *ngIf="!userPhonesFormExpanded">
            <div class="col-12">
                <serviceos-ng-system-icon
                    [icon]="'plus'"
                ></serviceos-ng-system-icon>
                <serviceos-ng-link
                    [type]="'primary'"
                    [size]="'small'"
                    [font_weight]="'semi-bold'"
                    (click)="userPhonesFormExpanded = !userPhonesFormExpanded"
                >
                    {{ phoneConfig?.add_button_title }}
                </serviceos-ng-link>
            </div>
        </div>
    </div>
</div>

<ng-template #noPhonesItem>
    <span class="no-phones-item">{{ phoneConfig?.empty_message }}</span>
</ng-template>
